import React, { useState } from 'react';

// Submitted to Netlify Forms. Netlify finds the form at deploy time from the
// hidden copy in public/index.html (its name and field names must match this
// one) and emails each submission to the address set in the Netlify dashboard,
// so no address appears on the site.
const FORM_NAME = 'contact';
const EMPTY = { name: '', email: '', message: '', 'bot-field': '' };

const encode = (data) => new URLSearchParams(data).toString();

function ContactForm() {
  const [fields, setFields] = useState(EMPTY);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const onChange = (e) => setFields({ ...fields, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({ 'form-name': FORM_NAME, ...fields }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setFields(EMPTY);
      setStatus('sent');
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="contact-sent" role="status">
        <strong>Thanks, your message is on its way.</strong>
        <span>We&apos;ll reply to the email address you gave us.</span>
        <button type="button" className="btn btn-ghost" onClick={() => setStatus('idle')}>
          Send another
        </button>
      </div>
    );
  }

  return (
    <form
      className="contact-form"
      name={FORM_NAME}
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      onSubmit={onSubmit}
    >
      <input type="hidden" name="form-name" value={FORM_NAME} />
      <p className="contact-honeypot" aria-hidden="true">
        <label>
          Leave this empty
          <input name="bot-field" tabIndex={-1} autoComplete="off" value={fields['bot-field']} onChange={onChange} />
        </label>
      </p>
      <div className="contact-row">
        <label className="contact-field">
          <span>Name</span>
          <input name="name" autoComplete="name" required value={fields.name} onChange={onChange} />
        </label>
        <label className="contact-field">
          <span>Email</span>
          <input type="email" name="email" autoComplete="email" required value={fields.email} onChange={onChange} />
        </label>
      </div>
      <label className="contact-field">
        <span>Message</span>
        <textarea name="message" rows={5} required value={fields.message} onChange={onChange} />
      </label>
      {status === 'error' && (
        <p className="contact-error" role="alert">
          Sorry, that didn&apos;t send. Please try again in a moment.
        </p>
      )}
      <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Send message'}
      </button>
    </form>
  );
}

export default ContactForm;
